import {useEffect} from 'react';

export interface UseRecentActivityPollingArgs {
  hasInProgress: boolean;
  pollIntervalMs: number;
  startPolling: (pollIntervalMs: number) => void;
  stopPolling: () => void;
  refetch: () => Promise<unknown>;
}

export default function useRecentActivityPolling({
  hasInProgress,
  pollIntervalMs,
  startPolling,
  stopPolling,
  refetch,
}: UseRecentActivityPollingArgs): void {
  useEffect(() => {
    if (!hasInProgress) {
      stopPolling();
      return undefined;
    }

    if (!document.hidden) {
      startPolling(pollIntervalMs);
    }

    const onVisibilityChange = (): void => {
      if (document.hidden) {
        stopPolling();
      } else {
        refetch().catch(() => {
          // Ignore refetch errors here so visibility toggles do not generate unhandled rejections.
        });
        startPolling(pollIntervalMs);
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      stopPolling();
    };
  }, [hasInProgress, pollIntervalMs, refetch, startPolling, stopPolling]);
}
